export default "__VITE_ASSET__801cd3ee__"